var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrackParking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 11.5,
    width: 489,
    height: 489,
    rx: 64.5,
    fill: "#106AAE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M274.5 110H172V403H230.571V315.1H274.5C330.143 315.1 377 268.22 377 212.55C377 156.88 330.143 110 274.5 110ZM274.5 256.5H230.571V168.6H274.5C297.929 168.6 318.429 189.11 318.429 212.55C318.429 235.99 297.929 256.5 274.5 256.5Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 11.5,
    width: 489,
    height: 489,
    rx: 64.5,
    stroke: "white",
    strokeWidth: 23
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackParking);
export default __webpack_public_path__ + "static/media/track-parking.06dc6c55ae1bfb1279a8b5829354f457.svg";
export { ForwardRef as ReactComponent };